module.exports = __webpack_public_path__ + "static/media/sched.1841255d.svg";